// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"cfa24fe5","239":"e39fb35b","455":"1b991356","570":"bbfb9ad9","977":"0296d865"}[chunkId] + ".chunk.js";
};